import envConfig from '@acre/config'

import createAxiosInstance from '../utils/createAxiosInstance'

const axiosInstance = createAxiosInstance({
  baseURL: envConfig.CH_API_URL,
})

export default axiosInstance
